import { Injectable, signal } from '@angular/core';

export interface ConfirmOpciones {
  titulo: string;
  mensaje: string;
  /** Texto del botón de confirmar (por defecto "Confirmar"). */
  confirmar?: string;
  /** Texto del botón de cancelar (por defecto "Cancelar"). */
  cancelar?: string;
  /** Estilo del botón de confirmar. */
  variante?: 'primary' | 'danger';
}

interface Peticion extends ConfirmOpciones {
  resolver: (valor: boolean) => void;
}

/**
 * Diálogos de confirmación reutilizables (reemplazan window.confirm).
 * Se resuelve una promesa con true/false según lo que elija el usuario.
 * El diálogo lo dibuja `<ui-confirm>`, montado una vez en la raíz de la app.
 *
 *   if (await this.confirm.confirmar({ titulo, mensaje, variante: 'danger' })) { … }
 */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  readonly peticion = signal<Peticion | null>(null);

  confirmar(opciones: ConfirmOpciones): Promise<boolean> {
    return new Promise((resolver) => this.peticion.set({ ...opciones, resolver }));
  }

  responder(valor: boolean): void {
    const actual = this.peticion();
    if (actual) {
      actual.resolver(valor);
      this.peticion.set(null);
    }
  }
}
